export const selectCartOfferComparisonSpoofedSelections = (state: App.State) => state.cartOfferComparison.spoofedSelections

export const selectCartActiveComparison = (state: App.State) => state.cartOfferComparison.activeComparison

export const selectIsCreatingCartOfferComparison = (state: App.State) => state.cartOfferComparison.loading
